import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const ClockIcon = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 12 12" {...props}>
      <path d="M6 1C8.757 1 11 3.243 11 6C11 8.757 8.757 11 6 11C3.243 11 1 8.757 1 6C1 3.243 3.243 1 6 1ZM6 0C2.6865 0 0 2.6865 0 6C0 9.3135 2.6865 12 6 12C9.3135 12 12 9.3135 12 6C12 2.6865 9.3135 0 6 0ZM8.924 6.2295C9.025 6.2485 9.025 6.396 8.9245 6.4155C7.971 6.596 5.902 6.971 5.651 6.971C5.2915 6.971 5.0005 6.68 5.0005 6.3205C5.0005 6.0645 5.3855 3.597 5.563 2.598C5.58 2.502 5.719 2.5075 5.7345 2.605L6.227 5.724L8.924 6.2295Z" />
    </SvgIcon>
  );
});
